require('~/js/templates/index/feature')
require('~/js/sections/collectionItems')
require('~/js/snippets/not-found')
import { createApp } from 'vue'
import FArticleFilter from '~/js/components/articleFilter'

const ID_DEFAULT = 'js-404-default'
const ID_FROM_BLOG = 'js-404-from-blog'
const LABELS_BLOG = {
  article: '記事',
  coordinate: 'コーディネート',
  feature: '特集記事',
}

document.addEventListener('DOMContentLoaded', () => {
  const element404 = document.getElementById(ID_FROM_BLOG)
  if (!element404) return

  const currentUrl = window.location.href.toLowerCase()
  const match = currentUrl.match(/\/blogs\/(.+?)\//)
  const blogHandle =
    match && Object.keys(LABELS_BLOG).includes(match[1]) ? match[1] : null
  if (!blogHandle) return
  const urlBack = `/blogs/${blogHandle}`

  const elementNotFoundContent = document.getElementById(ID_DEFAULT)
  elementNotFoundContent.style.display = 'none'

  createApp({
    name: 'Templates404',
    components: {
      FArticleFilter,
    },
    data() {
      return {
        baseUrl: `/blogs/${blogHandle}`,
        blogHandle,
        urlBack,
      }
    },
    computed: {
      label() {
        return blogHandle ? LABELS_BLOG[blogHandle] : ''
      },
    },
    mounted() {
      element404.style.display = 'block'
    },
  }).mount(element404)
})
